import cx from 'classnames';
import { SubscriptionOption } from 'models/stack9/SubscriptionOption';

import Card, { CardProps } from '../Card/Card';
import Checkbox from '../Checkbox/Checkbox';
import { CloseIcon } from '../Icons';

import s from './SubscriptionOptionCard.module.css';

export interface SubscriptionOptionProps extends Omit<CardProps, 'onChange'> {
  onChange?(value: boolean): any;
  selected?: boolean;
  subscriptionOption: SubscriptionOption;
}

const SubscriptionOptionCard = ({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChange = () => {},
  selected,
  subscriptionOption,
  className,
  ...props
}: SubscriptionOptionProps) => {
  return (
    <Card
      className={cx(
        className,
        s.root,
        {
          'outline-white': selected,
          'outline-transparent': !selected,
        },
        'shadow-card overflow-hidden cursor-pointer transition-all',
      )}
      borderRadius={['sm', 'md', '4xl', 'sm']}
      onClick={() => {
        onChange(!selected);
      }}
      {...props}
    >
      <div className="flex">
        <img
          src={subscriptionOption.image.url}
          alt={subscriptionOption.heading}
          className="hidden md:block w-[100px] lg:w-[200px] object-cover"
        />
        <div
          className={cx('flex flex-grow md:p-5 p-3 transition-colors', s.body, {
            'bg-blue-5': selected,
          })}
        >
          <Checkbox
            wrapperProps={{ className: 'pointer-events-none touch-none mt-1' }}
            checked={selected}
          >
            <CloseIcon className="text-coral-100" />
          </Checkbox>
          <div className="ml-3">
            <h3
              className={cx(
                'font-light text-dusty-blue-100 transition-colors',
                {
                  'text-dark-blue-100 font-medium': selected,
                },
              )}
            >
              {subscriptionOption.heading}
            </h3>
            <p
              dangerouslySetInnerHTML={{
                __html: subscriptionOption.description,
              }}
            />
          </div>
        </div>
        <div
          className={cx(
            'flex flex-col justify-between md:justify-end p-3 pb-5 w-[120px] flex-shrink-0 transition-colors',
            {
              'bg-blue-5': !selected,
              'bg-dark-blue-100': selected,
            },
          )}
        >
          <img
            src={subscriptionOption.image.url}
            alt={subscriptionOption.heading}
            className="block mb-3 -mx-3 -mt-3 max-w-none md:hidden object-cover"
          />
          <div className="mr-3 border-b-4 border-coral-100">
            <h3
              className={cx(
                'flex items-start mb-2 font-bold transition-colors',
                {
                  'text-dark-blue-100': !selected,
                  'text-white': selected,
                },
              )}
            >
              <span className="mt-1 mr-1 text-sm">$</span>
              <div>
                <span className="block">{subscriptionOption.dollar_value}</span>
                <span
                  className={cx('block text-sm font-normal transition-colors', {
                    'text-blue-100': !selected,
                    'text-white': selected,
                  })}
                >
                  per week
                </span>
              </div>
            </h3>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default SubscriptionOptionCard;
